import { render, staticRenderFns } from "./DialogPersonSelection.vue?vue&type=template&id=33d6cc58&scoped=true&"
import script from "./DialogPersonSelection.vue?vue&type=script&lang=js&"
export * from "./DialogPersonSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d6cc58",
  null
  
)

export default component.exports